var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconRolNobg = function SvgIconRolNobg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3H6v6.634H2V15h5.333V5.636h5.334v3.998h-4V15H14V3ZM3.333 10.975H6v2.684H3.333v-2.684Zm6.667 0h2.667v2.684H10v-2.684Z",
    fill: "#BEBEBE"
  })));
};

export { SvgIconRolNobg as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAzSDZWOS42MzM4NUgyVjE1SDcuMzMzMzJWNS42MzYxMUgxMi42NjY3VjkuNjMzODVIOC42NjY2OFYxNUgxNFYzWk0zLjMzMzMyIDEwLjk3NTRINlYxMy42NTg1SDMuMzMzMzJWMTAuOTc1NFpNMTAgMTAuOTc1NEgxMi42NjY3VjEzLjY1ODVIMTBWMTAuOTc1NFoiIGZpbGw9IiNCRUJFQkUiLz4KPC9zdmc+Cg==";